import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { StyledDialog, StyledCloseBtn, StyledDialogContentContainer, StyledDialogContent, StyledDialogDialogTitle, StyledDialogContentInside, StyledButtonArea } from './BasicDialog.styles.js';
import { ReactComponent as SvgIcCancel } from '../assets/img/ic_cancel.svg.js';
import Button from '../Button/Button.js';
import { COLOR, VARIANT } from '../constants/common.js';
const _excluded = ["open", "onClose", "backgroundClose", "closeBtnShow", "dialogTitle", "dialogContent", "dialogBottom", "confirmText", "cancelText", "onHandleConfirm", "color", "dialogRootStyle", "children"];
function BasicDialog(_ref) {
  let {
      open,
      onClose,
      backgroundClose,
      closeBtnShow,
      dialogTitle,
      dialogContent,
      dialogBottom,
      confirmText,
      cancelText,
      onHandleConfirm,
      color,
      dialogRootStyle,
      children
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const theme = useTheme();
  const renderBottomArea = () => {
    if (dialogBottom) {
      return dialogBottom;
    }
    return /*#__PURE__*/React__default.createElement(StyledButtonArea, null, confirmText && /*#__PURE__*/React__default.createElement(Button, {
      sx: {
        minWidth: '120px'
      },
      color: color,
      onClick: onHandleConfirm
    }, confirmText), cancelText && /*#__PURE__*/React__default.createElement(Button, {
      minWidth: "120px",
      sx: {
        marginTop: '5px',
        minWidth: '120px'
      },
      color: COLOR.INFO,
      variant: VARIANT.TEXT,
      onClick: onClose
    }, cancelText));
  };
  return /*#__PURE__*/React__default.createElement(StyledDialog, _extends({
    open: open,
    onClose: backgroundClose ? onClose : false,
    dialogRootStyle: dialogRootStyle
  }, otherProps), children ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      display: open ? 'flex' : 'none',
      flexDirection: 'column',
      overflow: 'hidden'
    }
  }, closeBtnShow && /*#__PURE__*/React__default.createElement(StyledCloseBtn, {
    size: 24,
    color: theme.customColors.grey[700],
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgIcCancel, null)), /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children)) : /*#__PURE__*/React__default.createElement(StyledDialogContentContainer, {
    sx: {
      display: open ? 'block' : 'none'
    }
  }, closeBtnShow && /*#__PURE__*/React__default.createElement(StyledCloseBtn, {
    size: 24,
    color: theme.customColors.grey[700],
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgIcCancel, null)), /*#__PURE__*/React__default.createElement(StyledDialogContent, null, /*#__PURE__*/React__default.createElement(StyledDialogDialogTitle, null, dialogTitle), /*#__PURE__*/React__default.createElement(StyledDialogContentInside, null, dialogContent), renderBottomArea())));
}
BasicDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  backgroundClose: PropTypes.bool,
  closeBtnShow: PropTypes.bool,
  dialogTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dialogContent: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dialogBottom: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  confirmText: PropTypes.string,
  cancelText: PropTypes.string,
  onHandleConfirm: PropTypes.func,
  color: PropTypes.oneOf(['primary', 'secondary', 'success', 'error', 'info', 'warning']),
  dialogRootStyle: PropTypes.shape({}),
  children: PropTypes.node
};
BasicDialog.defaultProps = {
  open: false,
  onClose: () => {},
  backgroundClose: true,
  closeBtnShow: true,
  dialogTitle: '',
  dialogContent: '',
  dialogBottom: '',
  confirmText: '',
  cancelText: '',
  onHandleConfirm: () => {},
  color: 'secondary',
  dialogRootStyle: {},
  children: null
};
export { BasicDialog as default };